<script>
export default {
  name: "DriversMixin",
  methods: {
    getStatusClass(status) {
      let color = "bg-grey-lighten-4 text-grey-darken-3";
      switch (status) {
        case "a":
          color = "bg-green-lighten-2 text-white";
          break;
        case "h":
          color = "bg-red-lighten-2 text-white";
          break;
        case "s":
          color = "bg-red-lighten-2 text-white";
          break;
      }
      return color;
    },
    getUserDocuments(user) {
      const docs = [];

      if (user.willingCrossBorderCanada) docs.push({ code: "CA", name: this.$t("drivers.cross-border-canada") });
      if (user.willingCrossBorderMexico) docs.push({ code: "MX", name: this.$t("drivers.cross-border-mexico") });

      if (user.certificateHazmatExpirationDate) {
        docs.push({
          code: "HAZ",
          name: this.$t("drivers.hazmat-certificate"),
          date: user.certificateHazmatExpirationDate,
        });
      }

      if (user.certificateTwicExpirationDate) {
        docs.push({
          code: "TWIC",
          name: this.$t("drivers.twic-certificate"),
          date: user.certificateTwicExpirationDate,
        });
      }

      if (user.certificateTsaExpirationDate) {
        docs.push({
          code: "TSA",
          name: this.$t("drivers.tsa-certificate"),
          date: user.certificateTsaExpirationDate,
        });
      }

      if (user.certificateTankerEndorsementExpirationDate) {
        docs.push({
          code: "TE",
          name: this.$t("drivers.tanker-certificate"),
          date: user.certificateTankerEndorsementExpirationDate,
        });
      }

      return docs;
    },
  },
};
</script>
